import React from 'react';

// Simple footer component
export const Footer: React.FC = () => {
  return (
    <footer className="py-8 text-center border-t border-gray-800 relative z-10">
      <p className="text-gray-400">© 2024 Joem Portfolio. Built with React & Tailwind CSS.</p>
    </footer>
  );
};
